export enum FeatureFlagKey {
  SUBSCRIPTION_PAYWALL = 'subscription_paywall',
  SHOW_PRICING_PAGE = 'show_pricing_page',
  LEGACY_USER_GRACE_PERIOD = 'legacy_user_grace_period',
  STRIPE_TEST_MODE = 'stripe_test_mode',
}

export enum RolloutStrategy {
  ALL_OR_NOTHING = 'all_or_nothing',
  PERCENTAGE = 'percentage',
  WHITELIST = 'whitelist',
  CUSTOM = 'custom',
}

export interface FeatureFlag {
  id: string;
  flag_key: FeatureFlagKey | string;
  flag_name: string;
  description: string | null;
  is_enabled: boolean;
  rollout_strategy: RolloutStrategy;
  rollout_percentage: number;
  enabled_for_user_ids: string[];
  enabled_for_emails: string[];
  targeting_rules: Record<string, any>;
  metadata: Record<string, any>;
  created_at: string;
  updated_at: string;
}

export interface FeatureFlagEvaluation {
  isEnabled: boolean;
  loading: boolean;
  error: Error | null;
}
